"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy, arrayMove, } from '@dnd-kit/sortable';
import { SortableItem } from './SortableItem';
export function SortableList({ items, onReorder, renderItem, disabled = false, className = '', }) {
    const sensors = useSensors(useSensor(PointerSensor, {
        activationConstraint: {
            distance: 8,
        },
    }), useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates,
    }));
    const itemIds = useMemo(() => items.map((item) => item.id), [items]);
    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (over && active.id !== over.id) {
            const oldIndex = items.findIndex((item) => item.id === active.id);
            const newIndex = items.findIndex((item) => item.id === over.id);
            if (oldIndex !== -1 && newIndex !== -1) {
                const reorderedItems = arrayMove(items, oldIndex, newIndex);
                onReorder(reorderedItems);
            }
        }
    };
    return (_jsx(DndContext, { sensors: sensors, collisionDetection: closestCenter, onDragEnd: handleDragEnd, children: _jsx(SortableContext, { items: itemIds, strategy: verticalListSortingStrategy, children: _jsx("div", { className: className, children: items.map((item) => (_jsx(SortableItem, { item: item, renderItem: renderItem, disabled: disabled }, item.id))) }) }) }));
}
export default SortableList;
//# sourceMappingURL=SortableList.js.map